// Converted to custom CSS (Tailwind removed)
// AOS initialized centrally in LandingPage
import NavBar from "./Navbar";

const TopComponent = () => {
  const isMobile = window.innerWidth <= 768;

  return (
    <div
      className="hero-wrapper"
      style={{
        margin: 0,
        padding: 0,
        width: "100%",
        minHeight: isMobile ? "40vh" : "70vh",
        overflow: "hidden",
      }}
    >
      <div data-aos="fade-down">
        <NavBar />
      </div>
      <div
        data-aos="zoom-in"
        className="hero-bg"
        style={{
          margin: 0,
          padding: 0,
          marginTop: "2rem",
          minHeight: isMobile ? "40vh" : "70vh",
          width: "100%",
          backgroundImage: "url('/couv-web-cytailor 1.svg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="lp-container hero-flex">
          <div
            data-aos="fade-up"
            className="hero-content"
            style={isMobile ? { transform: "translateY(-70px)" } : {}}
          >
            <h1 className="hero-title" style={{ color: "white" }}>
              Cyber risk reports built for business decision-makers.
            </h1>
            <p className="hero-paragraph" style={{ color: "white" }}>
              From technical noise to financial clarity, powered by an automated
              AI-driven risk engine.
            </p>

            {!isMobile && (
              <p className="hero-paragraph" style={{ color: "white" }}>
                CyTailor converts fragmented technical signals into a clear,
                unified view of cyber exposure, expressed in financial and
                business terms. In a single report, leadership understands where
                the organization is exposed, what realistic cyber incidents
                could cost, and which actions deliver the highest risk-reduction
                impact. The result is not a technical audit, but a
                decision-ready risk picture designed for executives.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopComponent;
